/* 设计部上传允许类型（2026-10-20 用户需求：增加 PPT 上传，各阶段都能传多种类型，例如 CDR）。
 *
 * 背景问题：原来每个上传入口各写一份 accept（阶段任务、交付物版本、机构附件、
 * 评论附件、产物会话、概念方案、设计变更…），而且都只到 pdf/图片/CAD/docx/xlsx ——
 * 于是 PPT 方案传不进、.doc/.xls 旧版传不进、CorelDRAW(.cdr) 也没有收录，
 * 用户只能先转 PDF，沟通用的源文件版本就散了。
 *
 * 现在统一成这一份，放在 lib 下（而不是页面目录），让 components/ 与 pages/ 都能引用，
 * 不产生「组件反向依赖页面」的耦合。后端对应 backend/design_const.py 的 DESIGN_UPLOAD_EXT，
 * 两边必须同步增删，否则会出现「选得到但后端 400」或者「后端收但选不到」。
 *
 * 取舍：只放开「设计沟通 / 交付真实会用到」的格式，不放开可执行文件与脚本
 * （exe / bat / sh / js 等）——上传后仍可下载，等于开了文件分发通道，属安全红线。
 * 体积上限仍由各入口自己把关（多为 60MB），加类型不等于放宽体积。
 */
export const DESIGN_UPLOAD_ACCEPT = [
  // 图纸 / 交付主格式
  ".pdf", ".dwg", ".dxf", ".rvt", ".skp", ".ifc",
  // 图片
  ".png", ".jpg", ".jpeg", ".webp", ".gif", ".heic", ".heif", ".bmp", ".tif", ".tiff", ".svg",
  // Office（含演示文稿）
  ".doc", ".docx", ".xls", ".xlsx", ".xlsm", ".ppt", ".pptx", ".csv", ".txt", ".rtf",
  // 设计源文件（含 CorelDRAW）
  ".cdr", ".ai", ".psd", ".indd", ".eps",
  // 压缩包（整套图纸 / 市府回执打包）
  ".zip", ".rar", ".7z",
  // 现场影音
  ".mp4", ".mov", ".m4v", ".webm", ".mp3", ".m4a", ".wav",
].join(",");

/* 可在浏览器里页内直接看（PDF / 图片）的后缀集合；Office / CAD / CDR 等只给下载入口。
   与后端 design_const.DESIGN_PREVIEW_EXT 同口径。
   刻意不含 heic / heif / tif / tiff：浏览器普遍不能解码，放进来预览会变破图；
   这些类型仍可上传，打开时走下载。 */
export const DESIGN_PREVIEW_EXT = new Set(["pdf", "png", "jpg", "jpeg", "webp", "gif", "bmp", "svg"]);

/* 后端白名单 → 前端 Set（用于提交前本地校验，给出「这个类型不支持」的即时提示，
   而不是等后端 400）。 */
export const DESIGN_UPLOAD_EXT = new Set(DESIGN_UPLOAD_ACCEPT.split(",").map((x) => x.slice(1)));
